import { Phone, MapPin } from 'lucide-react';
import { LANDING } from '@/constants/testIds';
import { BUSINESS } from '@/data/business';

export const MobileCTA = () => {
    return (
        <div className="fixed bottom-3 left-3 right-3 z-40 md:hidden flex gap-2">
            <a
                data-testid={LANDING.mobileCallBtn}
                href={`tel:${BUSINESS.phoneTel}`}
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3.5 bg-[#FFD500] text-black font-bold uppercase tracking-wider text-xs shadow-xl shadow-yellow-500/20 corner-cut"
            >
                <Phone className="h-4 w-4" />
                Appeler
            </a>
            <a
                data-testid={LANDING.mobileDirectionsBtn}
                href={BUSINESS.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3.5 bg-black/85 backdrop-blur border border-[#FFD500] text-[#FFD500] font-bold uppercase tracking-wider text-xs corner-cut"
            >
                <MapPin className="h-4 w-4" />
                Itinéraire
            </a>
        </div>
    );
};
